import React from 'react';

export default function OpenJobsHero() {
	return (
		<section className="open-jobs-hero">
			<div className="open-jobs-hero-inner">
				<div className="open-jobs-hero-content">
					<h1 className="open-jobs-hero-title">
						<span className="open-jobs-hero-title-lead">
							Looking for your next big
						</span>
						<span className="open-jobs-hero-title-accent">opportunity?</span>
					</h1>
					<p className="open-jobs-hero-subtitle">
						Explore our open roles and find where you can make an impact.
					</p>
				</div>
			</div>
		</section>
	);
}
